<template>
  <div :class="$style.inputContainer">
    <label
      :class="[$style.labelElement, 'type-label-large']"
      v-if="label || required"
      :for="name"
      >{{ label
      }}<span
        v-if="required"
        :class="$style.required"
        >*</span
      ></label
    >
    <input
      @blur="(e: Event) => $emit('blur', e)"
      :class="[$style.inputField, 'type-body-large']"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :maxlength="maxLength"
      :disabled="disabled"
      :autoFocus="autoFocus"
      :id="name"
      :name="name"
      :aria-invalid="error ? 'true' : undefined"
      :aria-describedby="error ? `${name}-error` : undefined"
      @input="handleInput"
      :required="required"
    />
    <p
      v-if="error"
      :id="`${name}-error`"
      :class="[$style.inputError, 'type-body-small']"
    >
      {{ error }}
    </p>
  </div>
</template>
<script setup lang="ts">
  const emit = defineEmits(['update:modelValue', 'blur'])

  interface InputProps {
    type?: string
    disabled?: boolean
    placeholder?: string
    name: string
    label?: string
    autoFocus?: boolean
    modelValue?: string | number | any
    error?: string
    required?: boolean
    max?: number
    min?: number
    maxLength?: number
  }
  withDefaults(defineProps<InputProps>(), {
    type: 'text',
    required: false,
    max: 1000000,
    min: 0,
    maxLength: undefined,
  })

  function handleInput(e: Event) {
    emit('update:modelValue', (e?.target as HTMLInputElement)?.value ?? '')
  }
</script>
<style module>
  .labelElement {
    width: 100%;
  }

  .inputField {
    border: 1px solid var(--color-field-border);
    height: 3rem;
    width: 100%;
  }

  .inputContainer {
    width: 100%;
    max-width: 520px;
  }

  .inputError {
    color: var(--color-status-error);
    margin: var(--space-8);
  }

  .required {
    color: var(--color-status-error);
    margin-left: var(--space-2);
  }
</style>
